import { Controller } from "@hotwired/stimulus";
import { BottomSheetSwipe } from "../helpers/bottom_sheet_swipe";

export default class extends Controller {
  connect() {
    if (this.shouldUseNonModalOpen()) {
      this.element.show();
    } else {
      this.element.showModal();
    }
    this.applyDefaultFocus();

    // Close and remove the dialog when Turbo navigates away, so it
    // doesn't briefly flash on the next page (morph keeps the DOM node).
    this.teardownOnNavigate = () => this.close();
    document.addEventListener("turbo:before-visit", this.teardownOnNavigate);

    // Initialize swipe-to-dismiss for mobile bottom sheets
    this.swipeHandler = new BottomSheetSwipe(this.element, {
      onDismiss: () => this.close(),
      canDismiss: () => true,
    });
  }

  disconnect() {
    this.swipeHandler?.destroy();
    document.removeEventListener("turbo:before-visit", this.teardownOnNavigate);
  }

  // Fullscreen dialogs inside a sidebar layout open non-modally on desktop
  // so the sidebar stays interactive. showModal() makes the rest of the
  // page inert (browser-level behaviour that CSS cannot override).
  shouldUseNonModalOpen() {
    const isFullscreen = this.element.classList.contains("dialog__container--fullscreen");
    const hasSidebar = document.body.classList.contains("has-sidebar");
    const isDesktop = window.matchMedia("(min-width: 800px)").matches;
    return isFullscreen && hasSidebar && isDesktop;
  }

  applyDefaultFocus() {
    if (this.element.querySelector("[autofocus]")) return;

    this.element.setAttribute("tabindex", "-1");
    this.element.focus({ preventScroll: true });
  }

  close() {
    try {
      this.element.close();
    } catch (_) {}
    this.element.closest("turbo-frame")?.remove();
    
    if (this.element.closest("#modals")) {
      this.element.remove();
    }
  }
}
